<template>
  <div>
    <h1 class="text-center">Block Inspector Not Implemented</h1>
    <!-- // TODO: Implement this tool -->
  </div>
</template>

<script>

export default {
  name: "Block-Inspector",
  data() {
    return {};
  },
  props: {},
  components: { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
